// extracted by mini-css-extract-plugin
export default {"formLayout":"AgeForm-module-formLayout-hw7l8"};